import { format, isValid, parseISO } from "date-fns";

export const formatShortDateTime = (
  date: string | Date | null | undefined,
): string => {
  if (!date) return "";
  try {
    const parsedDate = typeof date === "string" ? parseISO(date) : date;
    if (isValid(parsedDate)) {
      // Example: "Oct 27 6:32 PM" -> "Oct 27 6:32 pm"
      return format(parsedDate, "MMM d h:mm a").replace(/AM|PM/g, (m) =>
        m.toLowerCase(),
      );
    }
  } catch (e) {
    // fall through
  }
  return typeof date === "string" ? date : "";
};

export function stripSerial(barcode: string): string {
  return barcode.slice(-9);
}
